import { createAction } from "@reduxjs/toolkit";
import _omit from 'lodash/omit';
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

const attributes = [
  'id', 
  'first_name', 
  'last_name', 
  'display_name', 
  'locations', 
  'injuries', 
  'prompt', 
  'filter_prompt',
  'merge_prompt', 
  'synchronized', 
  'slots_count',
  'updated_at'
];

export const getClinicians = asyncThunkWrapper({ 
  model: 'clinicians', 
  action: 'getClinicians', 
  func: async ({ offset = 0, query = null }) => {
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes, ...(query && { query }) };
    const response = await axios.get('/clinicians', { params });

    return response.data;
  } 
});
export const getClinician = asyncThunkWrapper({ 
  model: 'clinicians', 
  action: 'getClinician', 
  func: async (id) => {
    const params = { attributes };
    const response = await axios.get(`/clinicians/${id}`, { params });

    return response.data;
  } 
});
export const createClinician = asyncThunkWrapper({ 
  model: 'clinicians', 
  action: 'createClinician', 
  func: async (clinician) => {
    const response = await axios.post('/clinicians', { clinician, attributes });

    return response.data;
  } 
});
export const updateClinician = asyncThunkWrapper({ 
  model: 'clinicians', 
  action: 'updateClinician', 
  func: async ({ id, ...fields }) => {
    const response = await axios.patch(`/clinicians/${id}`, { clinician: _omit(fields, ['localLocations']) });
      
    return { status: response.status, clinician: { id, ...fields } };
  } 
});
export const deleteClinician = asyncThunkWrapper({ 
  model: 'clinicians', 
  action: 'deleteClinician', 
  func: async (id) => {
    const response = await axios.delete(`/clinicians/${id}`);

    return { status: response.status, id };
  } 
});
export const clearLocalClinicians = createAction('clinicians/clearLocalClinicians');
export const clearLocalActiveClinician = createAction('clinicians/clearLocalActiveClinician');